import { DatePicker as BaseDatePicker, DatePickerProps } from 'antd';
import style from './index.module.scss';
import Paragraph from 'antd/lib/typography/Paragraph';

type TDatePicker = {
  datePickerType?: 'primary' | 'secondary';
  label: string;
} & DatePickerProps;

export const DatePicker = ({ datePickerType = 'primary', label, ...props }: TDatePicker) => {
  return (
    <div
      className={`${style.container} ${style[datePickerType]} ${
        props.className || ''
      }`}
    >
      <BaseDatePicker {...props} className={`${style.date}`} />
      <Paragraph className={style.label}>{label}</Paragraph>
    </div>
  );
};
